import { Grid } from '@material-ui/core';
import { EntityLayout, EntitySwitch, isKind } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { TechnologyRelationsGraphCard } from './TechnologyRelationsGraphCard';
import {
  ProjectAboutCard,
  RegionAboutCard,
  IndustryAboutCard,
  TechnologyAboutCard,
  TechnologiesCard,
} from '@internal/plugin-pulse';

const technologyEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={5} xs={12}>
          <TechnologyAboutCard />
        </Grid>
        <Grid item md={5} xs={12}>
          <EntityCatalogGraphCard
            height={400}
            title="Technology Relations"
            relations={['dependsOn', 'dependencyOf']}
          />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const regionEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={5} xs={12}>
          <RegionAboutCard />
        </Grid>
        <Grid item md={5} xs={12}>
          <EntityCatalogGraphCard height={400} title="Region Relations" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const industryEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={5} xs={12}>
          <IndustryAboutCard />
        </Grid>
        <Grid item md={5} xs={12}>
          <EntityCatalogGraphCard height={400} title="Industry Relations" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const projectEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6} xs={12}>
          <ProjectAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <TechnologiesCard />
        </Grid>
        <Grid item xs={12}>
          <TechnologyRelationsGraphCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('project')} children={projectEntityPage} />
    <EntitySwitch.Case
      if={isKind('technology')}
      children={technologyEntityPage}
    />
    <EntitySwitch.Case if={isKind('region')} children={regionEntityPage} />
    <EntitySwitch.Case if={isKind('industry')} children={industryEntityPage} />
  </EntitySwitch>
);
